var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.648 4.456a1.515 1.515 0 0 1 1.971 0l5.42 5.387 5.31-5.311a1.516 1.516 0 0 1 2.213 2.061l-5.38 5.38 5.38 5.35a1.516 1.516 0 0 1 0 2.213 1.52 1.52 0 0 1-1.151.364 1.52 1.52 0 0 1-1.062-.44l-5.327-5.327-5.403 5.403a1.52 1.52 0 0 1-1.06.364 1.52 1.52 0 0 1-1.076-.364 1.515 1.515 0 0 1 0-2.137l5.402-5.403-5.402-5.403a1.515 1.515 0 0 1 .165-2.137"
})));
export default SvgCross;